/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const sidebarWidth = 250;
  const { transparent, gradients, white, background } = palette;
  const { xxl } = boxShadows;
  const { pxToRem, linearGradient } = functions;

  let backgroundValue = darkMode
    ? background.sidenav
    : linearGradient(gradients.dark.main, gradients.dark.state);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // ----------------------------------------------------------------------
  // 1. EXPANDED SIDEBAR STYLES (miniSidenav = false)
  // ----------------------------------------------------------------------
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // ----------------------------------------------------------------------
  // 2. COLLAPSED SIDEBAR STYLES (miniSidenav = true)
  // ----------------------------------------------------------------------
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      
      // 🔥 FIX: FORCE SIDEBAR TO LEFT EDGE
      left: "0 !important",
      marginLeft: "0 !important",  // Removes the floating gap
      marginRight: "0 !important",
      
      // 🔥 OPTIONAL: REMOVE ROUNDED CORNERS ON LEFT (for a cleaner flush look)
      borderTopLeftRadius: "0 !important",
      borderBottomLeftRadius: "0 !important",

      // 🔥 ADJUST WIDTH (80px - 96px is standard for icons)
      width: pxToRem(96), 

      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "none",
      // Merge the correct style based on state
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});